export const investorURL = "/investor-relation";
